import { useEffect, useState } from 'react';
import { getItemOptions } from '../../api/options';
import { SearchAsYouType as SearchAsYouTypeBase } from '../shared/search-as-you-type';
import { Item } from './item-types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SearchAsYouType = SearchAsYouTypeBase as any;

interface ItemSearchInputProps {
  defaultItemId?: string;
  disabled?: boolean;
  onItemSelected?: (item: Item) => void;
  label?: string;
  error?: boolean;
}

export const ItemSearchInput = ({
  defaultItemId = '',
  disabled = false,
  onItemSelected = () => {},
  label = 'Select Item',
  error = false,
}: ItemSearchInputProps) => {
  const [itemId, setItemId] = useState('');

  useEffect(() => {
    const selectItem = async (itemId: string) => {
      const items = await getItemOptions({
        itemId,
      });
      const item = items?.find((i) => i.item_id === itemId);
      if (item) {
        onItemSelected(item);
      }
    };
    if (itemId != defaultItemId && defaultItemId) {
      setItemId(defaultItemId);
      selectItem(defaultItemId);
    }
  }, [defaultItemId]);

  return (
    <SearchAsYouType
      variant={'outlined'}
      label={label}
      value={itemId}
      disabled={disabled}
      error={error}
      onChange={(e: unknown, selectedItem: Item) => {
        if (selectedItem) {
          setItemId(selectedItem.item_id);
          onItemSelected(selectedItem);
        }
      }}
      onBlur={(e: unknown, selectedItem: Item) => {
        // Quick item entry without mouse clicks
        if (selectedItem) {
          setItemId(selectedItem.item_id);
          onItemSelected(selectedItem);
        }
      }}
      getSearchOptions={(searchString: string) =>
        getItemOptions({
          searchString,
        })
      }
    />
  );
};
